module.exports = __webpack_public_path__ + "img/1.3d20435b.jpg";